export enum CoverageCartRefreshActionType {
  EmitEvent = "emit_event",
  CallFunction = "call_function",
  RefreshPage = "refresh_page",
}
